<style/styles: any>
  .featurette {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas: "image" "text";
  }

  @media only screen and (min-width: 48em) {
    .featurette {
      grid-template-columns: 1fr 1fr;
      grid-template-areas: "image text";
    }
  }
</style>

export interface Input {
  content: Marko.Body;
}

<div class=[styles.featurette, "gap4 align-items-center grid pb2 pi1"]>
  <${input.content}/>
</div>
